module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_RO-84b94ef75b8a8a5d385eadea7ce9587b.svg";